import React from 'react';
import '../App.css';
import { SectionHeader, List, Footer } from 'design-system-idm';
import TwitterLogo from '../assests/logo-twitter.png';
import FBLogo from '../assests/logo-fb.png';
import InstaLogo from '../assests/logo-insta.png';
import City from '../assests/city.png';

function Involve() {
  return (
    <div className="involve">
    <div className="wrap">
      <div className="flex">
        <div className="pad-left width-50 mar-bot-3">
          <h1>Get Involved</h1>
            <p> Help us make Philadelphia Parks & Recreation even better.</p>
        </div>
        <img src={City} alt="city" className="mar-top-3"></img>
      </div>
      <SectionHeader
      title="Volunteer"
      BCKGDcolor="#8CD9DE"/>
      <div className="pad-left width-80 mar-bot-3">
        <p>Parks & Rec couldn’t thrive without volunteers. Volunteers help maintain parks and enhance recreation programming. There are lots of ways to help, from volunteering with an after-school program to joining a Park Friends group.</p>
    
      <a href="#" className="involve-links"><p>Business and individual volunteer opportunities</p></a>
      <a href="#" className="involve-links"><p>Community Gardens Network</p></a>
      <a href="#" className="involve-links"><p>Park Friends groups</p></a>
      <a href="#" className="involve-links"><p>Recreation Advisory Councils</p></a>
      
      </div>
    <SectionHeader
      title="Support"
      BCKGDcolor="#8CD9DE"/>
     <div className="pad-left width-80 mar-bot-3">
       <h3>Individual donations</h3>
       <p>You can support Parks & Rec by making a donation to these organizations.</p>
      <List
      list={[
        "Fairmount Park Conservancy works with Parks & Rec to lead and support efforts that preserve and improve the Parks & Rec system. Better parks and recreation facilities make for a better city that attracts businesses and new residents.",
        "Philadelphia Parks Alliance The mission of the Parks Alliance is to champion the public’s interest in outstanding parks, recreation, and open spaces – key to making Philadelphia a healthy, vibrant, and sustainable city for all.",
        "Gifts for All Seasons -The “Gifts for all Seasons” program offers you the opportunity to honor someone special, commemorate an occasion, or establish a memorial with a donation of a tree or grove. To begin the tree donation process, call (215) 683-0215."
      ]}
      />
      <h3>Sponsorships</h3>
      <p>Parks & Rec holds over 600 events and thousands of programs each year. We welcome sponsors. Corporate sponsors receive valuable benefits while contributing to a stronger city. Those interested in sponsoring an event or program can contact Tiffany Thurman, Chief of Staff to the Commissioner, at (215) 683-3652.</p>
        
      </div>


     </div>
     <Footer
      BCKGDcolorLinks="#15AF53"
      BCKGDcolorContact="#03944f"
      links={[{
          href: "#",
          text: "Documents and forms"
        },{
          href: "#",
          text: "Press Releases"
        },{
          href: "#",
          text: "Rules and regulations"
        },{
          href: "#",
          text: "Fairmount Park Conservancy"
        },{
          href: "#",
          text: "Philadelphia Parks Alliance"
        },
      ]}
      address="1515 Arch Street, Philadelphia, PA 19102"
      email="parksandrecreation@phila.gov"
      phone="(215) 683-3600"
      logoTwitter={TwitterLogo}
      logoFB={FBLogo}
      logoInsta={InstaLogo}
      />
    </div>
  );
}

export default Involve;
